var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.688,
    height: 14.691,
    viewBox: "0 0 14.688 14.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_029---Lane-Split",
    "data-name": "029---Lane-Split",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M3.085,1.1.053,5.415a.25.25,0,0,0,.205.4h1.52v.76a6.54,6.54,0,0,0,2.234,4.924l.623.545a3.505,3.505,0,0,1,1.2,2.637v.76a.253.253,0,0,0,.253.253H8.617a.253.253,0,0,0,.253-.253v-.76A6.579,6.579,0,0,0,6.636,9.752l-.623-.545a3.505,3.505,0,0,1-1.2-2.637v-.76h1.52a.25.25,0,0,0,.205-.4L3.495,1.1a.254.254,0,0,0-.41,0Z",
    transform: "translate(-0.006 -0.998)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M30.768,5.56a.252.252,0,0,0,.253.251h1.52v.76a3.505,3.505,0,0,1-1.2,2.637l-.623.545c-.129.114-.253.233-.372.355.015.02.033.038.048.058a7.018,7.018,0,0,1,1.472,3,3.463,3.463,0,0,1,.854-1.13l.623-.545A6.54,6.54,0,0,0,35.58,6.57v-.76H37.1a.25.25,0,0,0,.205-.4L34.258,1.1a.254.254,0,0,0-.41,0L30.816,5.415A.247.247,0,0,0,30.768,5.56Z",
    transform: "translate(-22.664 -0.998)",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/templates.b79437ded3696ef5040a733e1d11fa93.svg";
export { ForwardRef as ReactComponent };